import type { EnvTag } from "@peerup/auth-kit"

import { AuthKit } from "@peerup/auth-kit"
import createPiniaStore from "@peerup/auth-kit/createPiniaStore"

import { envConfig, getGlobalData, isTest } from "@/config"

import { store } from "../index"

const data = getGlobalData()

/**
 * 全局authKit，管理用户信息与登录状态
 */
export const $authKit = data?.authKit || new AuthKit({
  host: envConfig.VITE_APP_DOMAIN_URL,
  envTag: envConfig.VITE_APP_ENV as string as EnvTag,
  silence: !isTest,
  allowCrossDomain: [envConfig.COOKIE_DOMAIN],
  staticOrigin: envConfig.PRIVATE_PUBLIC_LINK_OFF ? window.location.origin : undefined,
  useCookieNativeStorage: false,
  revalidateInterval: 10 * 1000,
  // allowCrossDomain: [
  //   "https://sit.peerup.com",
  //   "https://sit1.peerup.com",
  //   "https://dev.peerup.com",
  //   isDev ? "https://localhost:3100" : "",
  // ].filter(Boolean),
  // cookieDomain: ".peerup.com",
})
console.log("[accounts]authKit", $authKit, data?.authKit);
(window as any).authKit = $authKit
/**
 * 创建 auth 模块，用于获取响应式用户信息和token
 */
export const useAuthStore = createPiniaStore($authKit, {
  pinia: store,
})
